export default "__VITE_ASSET__C8ljesKp__"